import React, { useEffect, useRef, useState } from "react";
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import {
  EventReqDtos,
  HospitalCenterReqDto,
  LeadsDto,
} from "../../../api/interfaces/LeadsDto";
import { useForm } from "react-hook-form";
import { mtCountryDto, mtCurrencyDto } from "../../../api/interfaces/addUser";
import { getCurrencySymbol } from "../../../utility/RolesUtility";
import { useLoader } from "../../../Loader/LoaderContext";
import { getService, postService } from "../../../servce/ApisService";
import { API_ENDPOINTS } from "../../../api";
import ConfirmationModal from "../Modals/confirmationPopup";
import moment from "moment";
import { useToaster } from "../../../Toaster/Toaster";
import Sucesspopup from "../Modals/SucessPopup";
import { LeadsContinents } from "../../../api/interfaces/LeadsContinent";

type FilterType = {
  role: string[];
  status: string[];
  leads: string[];
  addedByLeads: number[];
  statusInPosts: string[];
  serviceFilterInPosts: string[];
  featuredTypeFilter?: string;
  bookings: string[];
};
type SortType = {
  column: string;
  direction: number;
};

const AddBooking = () => {
  const {
    register,
    handleSubmit,
    control,
    watch,
    setValue,
    reset,
    clearErrors,
    formState: { errors, isValid, isSubmitting, touchedFields },
  } = useForm<LeadsDto>({
    mode: "onChange",
    defaultValues: {
      eventReqDtos: [
        {
          name: "",
          startDate: "",
          endDate: "",
          contactPersonName: "",
          contactPersonEmail: "",
          phoneNo: "",
          venue: "",
          type: "",
          mtCountryDto: { id: 0, name: "", isoCode: "", code: "" },
        },
      ],
    },
  });
  const isAnyServiceSelected = () => {
    // Check if any of the relevant checkboxes are checked
    return (
      formData.isContentMarketing ||
      formData.isHospitalProfiling ||
      formData.isCompanyProfiling ||
      formData.isEventProfiling ||
      formData.isEventListing ||
      formData.isCenterListing ||
      formData.isBannerAds ||
      formData.isEmailMarketing ||  
      formData.isNewsLetterAds ||
      formData.isContentMarketing ||
      formData.isPrintAd
    );
  };
  const getFormattedTodayDate = () => {
    return new Date().toISOString().split("T")[0]; // Format today as 'YYYY-MM-DD'
  };

  const navigate = useNavigate();
  const { setLoading } = useLoader();
  const { showToast } = useToaster();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const bookingId = searchParams.get("bookingId");
  const leadId = searchParams.get("leadId");
  const userId = searchParams.get("leadId");
  const [file, setFile] = useState<(File | null)[]>([]);
  const [selectedType, setType] = useState("");
  const [selectedTypes, setSelectedType] = useState("PAID");
  const [events, setEvents] = useState<EventReqDtos[]>([]);
  const [centerEvents, setCenterEvents] = useState<HospitalCenterReqDto[]>([]);
  const [currencyCodes, setSelectedCurrency] = useState("2" || 2);
  const [mtCurrencyData, setMtCurrency] = useState<mtCurrencyDto[]>([]);
  const today = new Date().toISOString().split("T")[0];
  const [submittedData, setSubmittedData] = useState<LeadsDto | null>(null);
  const [data, setData] = useState<LeadsDto | null>(null);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [phoneCode, setPhonecode] = useState({ isoCode: "", code: "" });
  const [isDisabled, setIsDisable] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [selectedFile, setSelectedFile] = useState<string[]>([]);
  const fileInputRef = useRef<HTMLInputElement[]>([]);
  const [selectedDate, setSelectedDate] = useState(today);
  const [alternatephoneCode, setAltPhonecode] = useState({
    isoCode: "",
    code: "",
  });
  const [isBollen, seTisBollen] = useState(false);
  const [isShow, setIsShow] = useState(false);
  const [continents, setContinent] = useState<LeadsContinents[]>([]);
  const [mtContryData, setMtCountry] = useState<mtCountryDto[]>([]);
  const [selectedContinent, setSelectedContinent] = useState<string>("");
  const [expanded, setExpanded] = useState<string | false>(false);
  const [selectedCountry, setSelectedCountry] = useState("");
  const [selectedContry, setSelectedContry] = useState<string>("");
  const [filters, setFilters] = useState<FilterType>({
    role: [],
    status: [],
    bookings: [],
    leads: [],
    addedByLeads: [],
    statusInPosts: [],
    serviceFilterInPosts: [],
    featuredTypeFilter: "",
  });
  const [isFilterPopupOpen, setIsFilterPopupOpen] = useState(false);
  const [filterCount, setFilterCount] = useState(0);
  const [isRefreshPage, setisRefreshPage] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState<number | null>(null);
  const [currentPage, setCurrentPage] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  const [sort, setSort] = useState<SortType>({ column: "", direction: 1 });
  const addedBy = searchParams.get("addedBy");
  const [startDate, setStartDate] = useState(today); // Initialize startDate state
  const [endDate, setEndDate] = useState("");
  const [endDate1, setEndDate1] = useState("");
  const [endDate2, setEndDate2] = useState("");
  const [responseData,setResponseData] = useState<string | null>(null);  

  const handleStartDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const selectedDate = e.target.value;
    setStartDate(selectedDate); // Update start date
    const nextDay = new Date(selectedDate);
    nextDay.setDate(nextDay.getDate() + 1); // Set next day after the selected start date
    setEndDate(nextDay.toISOString().split("T")[0]); // Update end date state to be the next day
  };
  const handleStartDateChange1 = (e: React.ChangeEvent<HTMLInputElement>) => {
    const selectedDate = e.target.value;
    setStartDate(selectedDate); // Update start date
    const nextDay = new Date(selectedDate);
    nextDay.setDate(nextDay.getDate() + 1); // Set next day after the selected start date
    setEndDate1(nextDay.toISOString().split("T")[0]); // Update end date state to be the next day
  };
  const handleStartDateChange2 = (e: React.ChangeEvent<HTMLInputElement>) => {
    const selectedDate = e.target.value;
    setStartDate(selectedDate); // Update start date
    const nextDay = new Date(selectedDate);
    nextDay.setDate(nextDay.getDate() + 1); // Set next day after the selected start date
    setEndDate2(nextDay.toISOString().split("T")[0]); // Update end date state to be the next day
  };

  const dropdownRef = useRef<HTMLDivElement | null>(null);
  const handleClickOutside = (event: any) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setActiveDropdown(null);
    }
  };
  const proposals = () => {
    navigate("/portals/proposals/viewProposal");
  };
  const handleFileChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    index: number
  ) => {
    const file = event.target.files?.[0];
    const allowedTypes = ["image/png", "image/jpeg"];
    const maxSizeInMB = 3;

    if (file) {
      // Validate file type
      if (!allowedTypes.includes(file.type)) {
        alert("Please select a valid image (PNG or JPG).");
        return;
      }

      // Validate file size
      if (file.size > maxSizeInMB * 1024 * 1024) {
        alert(`File size should not exceed ${maxSizeInMB} MB.`);
        return;
      }

      // Create a file URL
      const fileUrl = URL.createObjectURL(file);

      // Update the file array
      setFile((prevFiles) => {
        const updatedFiles = [...prevFiles];
        updatedFiles[index] = file; // Assign the file at the given index
        return updatedFiles;
      });

      // Update the preview URL array
      setSelectedFile((prevUrls) => {
        const updatedUrls = [...prevUrls];
        updatedUrls[index] = fileUrl; // Assign the URL at the given index
        return updatedUrls;
      });
    }
  };
  const reUploadFile = (index: number) => {
    if (fileInputRef.current[index]) {
      fileInputRef.current[index].click();
    }
  };
  const clearFile = (index: number) => {
    // Implement your logic to clear the file
    setFile((prevFiles) => {
      const updatedFiles = [...prevFiles];
      updatedFiles[index] = null;
      return updatedFiles;
    });
  };

  const handleTypeChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedValue = event.target.value;
    setFile([]);
    setType(selectedValue);
    setSelectedType(selectedValue);
    // Clear error if a valid type is selected
    if (selectedValue) {
      clearErrors("type");
    }
    if (selectedValue === "BARTER") {
      clearErrors("value"); // Clear errors for 'value' if 'BARTER' is selected
    }
    setValue("type", selectedValue);
  };
  const handleDateClick = (e: React.MouseEvent<HTMLInputElement>) => {
    e.preventDefault(); // Prevent default click action if needed
    e.currentTarget.showPicker(); // Re-focus to trigger the date picker again
  };
  const handleDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedDate(e.target.value);
    setValue("bookingDate", e.target.value); // Set value in React Hook Form
  };

  const currencyCode = (e: any) => {
    const selectedCurrency = e.target.value;
    setSelectedCurrency(selectedCurrency);
  };
  const mtCurrencyDtoData = async () => {
    setLoading(true);
    try {
      const response = await getService(API_ENDPOINTS.mtCurrency);
      setMtCurrency(response.data);
    } catch (error) {
      console.error("Error fetching vehicle data:", error);
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 500);
    }
  };

  const usersScreen = () => {
    if(bookingId){
      navigate("/portals/bookings/viewBooking");
    }else{
      navigate("/portals/proposals/viewProposal");
    }
  };

  // const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>, type: keyof FilterType) => {
  //   const { checked, value } = e.target;
  // }

  const [formData, setFormData] = useState({
    proposalId: 0,
    isHospitalProfiling: false,
    isCenterListing: false,
    isBannerAds: false,
    isEmailMarketing: false,
    isNewsLetterAds: false,
    isContentMarketing: false,
    printAdd: 0,
    isPrintAd: false,
    isEventProfiling: false,
    isCompanyProfiling: false,
    isEventListing: false,
    noOfPrintAds: 0,
    noOfNewsBanners: 0,
    noOfPosts: 0,
    noOfEdms: 0,
    noOfRecipients: 0,
    noOfBanners: 0,
    value: 0,
    eventIdList: [],
    // Add other checkboxes as needed
  });

  // Define the type for the search parameter
  const getQueryParams = (search: string): URLSearchParams => {
    return new URLSearchParams(search);
  };

  useEffect(() => {
    const queryParams = getQueryParams(location.search);
    const bookingId = queryParams.get("bookingId"); // Get leadId from query params
    if (bookingId) {
      setFormData((prevData) => ({
        ...prevData,
        proposalId: parseInt(bookingId, 10), // Assign bookingId to proposalId
      }));
    }
  }, [location.search]);
  // Separate effect for `isEditMode` to set `isDisabled`
  // Assume bookingId is passed as a prop
useEffect(() => {
  if (bookingId) {
    setIsEditMode(true);
  } else {
    setIsEditMode(false);
  }
}, [bookingId]);
  useEffect(() => {
    // fetchVehicles();
    if (Object.keys(filters).length > 0) {
      let count = 0;
      Object.values(filters).forEach((filter) => {
        count += filter.length;
      });
      setFilterCount(count);
      fetchVehicles();
    }
    if (isRefreshPage) {
      fetchVehicles(); // Refresh data if triggered
      setisRefreshPage(false); // Reset the refresh trigger
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [currentPage, searchQuery, filters, sort, addedBy, isRefreshPage]);

  const handleCheckboxChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    field: keyof typeof formData
  ) => {
    setFormData((prevData) => ({
      ...prevData,
      [field]: e.target.checked, // Update the value based on the checkbox state
    }));
  };
  const handleDownloadBookingForm = async (user: any) => {
    setIsShow(false);
    navigate('/portals/bookings/viewBooking');
    let apiUrl = "";
    function base64ToArrayBuffer(base64: string) {
      const binaryString = window.atob(base64); // Decode base64 string
      const len = binaryString.length;
      const bytes = new Uint8Array(len); // Create a Uint8Array from binary string
      for (let i = 0; i < len; i++) {
        bytes[i] = binaryString.charCodeAt(i); // Convert each char to binary
      }
      return bytes.buffer;
    }
    if (userInfo.roles === "SALES_MANAGER") {
      apiUrl = API_ENDPOINTS.salesManagerDownloadBookingForm;
    } else if (userInfo.roles === "SALES_ADMIN") {
      apiUrl = API_ENDPOINTS.salesAdminDownloadBookingForm;
    } else if (userInfo.roles === "SALES_TEAM_LEAD") {
      apiUrl = API_ENDPOINTS.salesTlDownloadBookingForm;
    } else if (userInfo.roles === "SALES_EXECUTIVE") {
      apiUrl = API_ENDPOINTS.salesExecutiveDownloadBookingForm;
    }

    try {
      let id:any;
      const response = await getService(`${apiUrl}?bookingId=${responseData}`);
      if (response.data && response.data.base64Str) {
        // Convert the base64 string into a Blob URL for downloading
        const arrayBuffer = base64ToArrayBuffer(response.data.base64Str);
        const downloadUrl = window.URL.createObjectURL(
          new Blob([arrayBuffer], { type: "application/pdf" })
        );

        // Create an anchor element to trigger the download
        const link = document.createElement("a");
        link.href = downloadUrl;
        link.setAttribute("download", response.data.name || "bookingForm.pdf"); // Set filename
        document.body.appendChild(link);
        link.click();

        // Cleanup: Remove the link and revoke the Blob URL
        document.body.removeChild(link);
        window.URL.revokeObjectURL(downloadUrl);
      } else {
        console.error("No valid base64 string found in the response data");
      }
    } catch (error) {
      console.error("Error downloading the order form:", error);
    }
  };

  // const viewUsers = () => {
  //   setIsShow(false);
  //   navigate("/portals/bookings/viewBooking");
  // };

  const closePopup = () => {
    setIsShow(false);
    setTimeout(() => {
      navigate("/portals/bookings/viewBooking");
      window.location.reload();
    }, 500);
  };

  const mtContinetData = async () => {
    setLoading(true);
    try {
      const response = await getService(API_ENDPOINTS.mtCotinent);
      setContinent(response.data);
    } catch (error) {
      console.error("Error fetching vehicle data:", error);
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 500);
    }
  };
  const mtCountryDtoData = async () => {
    setLoading(true);
    try {
      const response = await getService(API_ENDPOINTS.countryData);
      setMtCountry(response.data);
    } catch (error) {
      console.error("Error fetching vehicle data:", error);
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 500);
    }
  };

  const userInfo = JSON.parse(localStorage.getItem("userInfo") || "{}");
  useEffect(() => {
    mtContinetData();
    mtCountryDtoData();
    mtCurrencyDtoData();
    if (bookingId || leadId) {
      fetchVehicles();
    } else {
      resetFormData(); // Reset the form when there's no userId
    }
  }, [location]);
  const resetFormData = () => {
    const emptyData = {
      uuid: "",
      bookingDate: "",
      id: 0,
      type: "",
      source: "",
      companyName: "",
      contactPersonName: "",
      email: "",
      callBackDate: "",
      contactNo: "",
      website: "",
      sourceUrl: "",
      feedback: "",
      mtContinentDto: {
        id: 0,
        continent: "",
        name: "",
      },
      directNo: "",
      startDate: "",
      endDate: "",
      leadRespDto: {
        address: '',
  companyName: '',
  contactPersonName: '',
  contactPerson: '',
  directNo: '',
  contactNo: 0,
  contactPersonRole: '',
  website: '',
  sourceUrl:'',
  mtContinentDto: {
    id:0, continent:'', name:''
  },
  callBackDate: '',
  mtCountryDto: {
    id: 0,
    name:'',
    code:'',
    isoCode:''
  },
  feedback:'',
  pitchedBy: '',
  eventReqDtos: [],
      eventRespDtos: [],
      centerRespDtos: [],
      centerReqDtos: [],
      },
      eventReqDtos: [],
      eventRespDtos: [],
      centerRespDtos: [],
      centerReqDtos: [],
      alternateIsoCode: "",
      phoneisoCode: "",
      addedBy: "",
      addedDate: "",
      status: "",
    };
    reset(emptyData);
    setSubmittedData(emptyData);
  };

  const fetchVehicles = async () => {
    setLoading(true);
    try {
      // Replace with your specific API endpoint for booking
      let url: any;
      if (leadId) {
        if (userInfo.roles === "SALES_MANAGER") {
          url = API_ENDPOINTS.salesManagerLeadsApi;
        } else if (userInfo.roles === "SALES_ADMIN") {
          url = API_ENDPOINTS.salesGetLeadsApi;
        } else if (userInfo.roles === "SALES_TEAM_LEAD") {
          url = API_ENDPOINTS.salesTlLeadsApi;
        } else if (userInfo.roles === "SALES_EXECUTIVE") {
          url = API_ENDPOINTS.salesExicuteLeadsApi;
        }
        const response = await getService(`${url}?leadId=${leadId}`);
        setSubmittedData(response.data);
        // Ensure formData is set with the API response, including checkbox values
        setFormData({
          ...formData,
          isBannerAds: !!response.data.isBannerAds, // Map the checkbox value
          isHospitalProfiling: !!response.data.isHospitalProfiling,
          isCenterListing: !!response.data.isCenterListing,
          isEmailMarketing: !!response.data.isEmailMarketing,
          isNewsLetterAds: !!response.data.isNewsLetterAds,
          isContentMarketing: !!response.data.isContentMarketing,
          isEventProfiling: !!response.data.isEventProfiling,
          isCompanyProfiling: !!response.data.isCompanyProfiling,
          isEventListing: !!response.data.isEventListing,
          isPrintAd: !!response.data.isPrintAd,
          // Similarly map other checkbox fields and form data
        });
      } else if (bookingId) {
        if (userInfo.roles === "SALES_MANAGER") {
          url = API_ENDPOINTS.editSalesManagerProposalBooking;
        } else if (userInfo.roles === "SALES_ADMIN") {
          url = API_ENDPOINTS.editSalesAdminProposalBooking;
        } else if (userInfo.roles === "SALES_TEAM_LEAD") {
          url = API_ENDPOINTS.editSalesTlProposalBooking;
        } else if (userInfo.roles === "SALES_EXECUTIVE") {
          url = API_ENDPOINTS.editSalesExecutiveProposalBooking;
        }
        const response = await getService(`${url}?bookingId=${bookingId}`);
        setSubmittedData(response.data);
        // Ensure formData is set with the API response, including checkbox values
        setFormData({
          ...formData,
          isHospitalProfiling: !!response.data.isHospitalProfiling,
          isCenterListing: !!response.data.isCenterListing,
          isBannerAds: !!response.data.isBannerAds,
          isEmailMarketing: !!response.data.isEmailMarketing,
          isNewsLetterAds: !!response.data.isNewsLetterAds,
          isContentMarketing: !!response.data.isContentMarketing,
          isEventProfiling: !!response.data.isEventProfiling,
          isCompanyProfiling: !!response.data.isCompanyProfiling,
          isEventListing: !!response.data.isEventListing,
          isPrintAd: !!response.data.isPrintAd,
        });
        setSelectedType(response.data.type);
        reset({
          ...response.data, // Resetting other data from the response
          type: response.data.type,
          additionalService: response.data.additionalService,
          mtCurrencyDto: response.data?.mtCurrencyDto?.id,
          trialEndDate: response.data.trialEndDate
            ? moment(response.data.trialEndDate, "DD/MM/YYYY").format(
                "YYYY-MM-DD"
              )
            : "",
          inviteEndDate: response.data.inviteEndDate
            ? moment(response.data.inviteEndDate, "DD/MM/YYYY").format(
                "YYYY-MM-DD"
              )
            : "",
          bannerAdFrom: response.data.bannerAdFrom
            ? moment(response.data.bannerAdFrom, "DD/MM/YYYY").format(
                "YYYY-MM-DD"
              )
            : "",
          bannerAdTo: response.data.bannerAdTo
            ? moment(response.data.bannerAdTo, "DD/MM/YYYY").format(
                "YYYY-MM-DD"
              )
            : "",
          bookingDate: response.data.bookingDate
            ? moment(response.data.bookingDate, "DD/MM/YYYY").format(
                "YYYY-MM-DD"
              )
            : "",
          contntMarktAdFrom: response.data.contntMarktAdFrom
            ? moment(response.data.contntMarktAdFrom, "DD/MM/YYYY").format(
                "YYYY-MM-DD"
              )
            : "",
          contntMarktAdTo: response.data.contntMarktAdTo
            ? moment(response.data.contntMarktAdTo, "DD/MM/YYYY").format(
                "YYYY-MM-DD"
              )
            : "",
          newsLetterAdFrom: response.data.newsLetterAdFrom
            ? moment(response.data.newsLetterAdFrom, "DD/MM/YYYY").format(
                "YYYY-MM-DD"
              )
            : "",
          newsLetterAdTo: response.data.newsLetterAdTo
            ? moment(response.data.newsLetterAdTo, "DD/MM/YYYY").format(
                "YYYY-MM-DD"
              )
            : "",
          id: response.data.id,
          isHospitalProfiling: !!response.data.isHospitalProfiling,
          isCenterListing: !!response.data.isCenterListing,
          isBannerAds: !!response.data.isBannerAds,
          isEmailMarketing: !!response.data.isEmailMarketing,
          isNewsLetterAds: !!response.data.isNewsLetterAds,
          isContentMarketing: !!response.data.isContentMarketing,
          isEventProfiling: !!response.data.isEventProfiling,
          isCompanyProfiling: !!response.data.isCompanyProfiling,
          isEventListing: !!response.data.isEventListing,
          isPrintAd: !!response.data.isPrintAd,
          noOfBanners: response.data.noOfBanners,
          noOfEdms: response.data.noOfEdms,
          noOfNewsBanners: response.data.noOfNewsBanners,
          noOfPosts: response.data.noOfPosts,
          noOfPrintAds: response.data.noOfPrintAds,
          noOfRecipients: response.data.noOfRecipients,
          printAdType: response.data.printAdType,
          value: response.data.value,
          printAdd: response.data.printAdd,
          
        });
        setSelectedCurrency(response.data?.mtCurrencyDto?.id);
        getCurrencySymbol(response.data?.mtCurrencyDto?.id);
        setSubmittedData(response.data);
        setType(response.data.type);
      }
    } catch (error) {
      console.error("Error booking proposal:", error);
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 500);
    }
  };
  

  const handleAddEvent = () => {
    const newEventId = events.length + 1;
    setEvents([
      ...events,
      {
        id: newEventId,
        name: `Event ${newEventId}`,
        startDate: "",
        endDate: "",
        contactPersonName: "",
        contactPersonEmail: "",
        phoneNo: "",
        mtCountryDto: {
          id: null,
          name: "",
          code: "",
          isoCode: "",
        }, // Default mtCountryDto object
        venue: "",
        link: "",
        type: "",
        imageDto: {
          name: "",
          base64Str: "",
          type: "",
          documentUrl: "",
        },
      },
    ]);
    setExpanded(`panel${newEventId}`);
  };

  const onSubmit = async (data: LeadsDto) => {
    setData(data);
    handleOpenPopup();
  };
  const handleOpenPopup = () => setIsPopupOpen(true);
  const handleClosePopup = () => {
    setIsPopupOpen(false);
  }
  const handleConfirm = async () => {
    handleClosePopup();
    setLoading(true);
    try {
      let response;
      let url: any;
      const convertFileToBase64 = (file: File): Promise<string> => {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => resolve(reader.result as string);
          reader.onerror = (error) => reject(error);
        });
      };
      let payload: any = {
        type: data?.type,
        mtCurrencyDto: {
          id: parseInt(data?.mtCurrencyDto as unknown as string, 10),
        },
        value: parseFloat(data?.value as unknown as string),
        // value: data?.value,
        bookingDate: data?.bookingDate
          ? moment(data?.bookingDate, "YYYY-MM-DD").format("DD/MM/YYYY")
          : "",
        isHospitalProfiling: formData?.isHospitalProfiling,
        isCenterListing: formData?.isCenterListing,
        isEventListing: formData?.isEventListing,
        isBannerAds: formData?.isBannerAds,
        bannerAdFrom: data?.bannerAdFrom
          ? moment(data?.bannerAdFrom, "YYYY-MM-DD").format("DD/MM/YYYY")
          : "",
        trialEndDate: data?.trialEndDate
          ? moment(data?.trialEndDate, "YYYY-MM-DD").format("DD/MM/YYYY")
          : "",
        inviteEndDate: data?.inviteEndDate
          ? moment(data?.inviteEndDate, "YYYY-MM-DD").format("DD/MM/YYYY")
          : "",
        bannerAdTo: data?.bannerAdTo
          ? moment(data?.bannerAdTo, "YYYY-MM-DD").format("DD/MM/YYYY")
          : "",
        noOfBanners: data?.noOfBanners,
        isEmailMarketing: formData?.isEmailMarketing,
        noOfRecipients: data?.noOfRecipients,
        noOfEdms: data?.noOfEdms,
        isNewsLetterAds: formData?.isNewsLetterAds,
        newsLetterAdFrom: data?.newsLetterAdFrom
          ? moment(data?.newsLetterAdFrom, "YYYY-MM-DD").format("DD/MM/YYYY")
          : "",
        newsLetterAdTo: data?.newsLetterAdTo
          ? moment(data?.newsLetterAdTo, "YYYY-MM-DD").format("DD/MM/YYYY")
          : "",
        noOfNewsBanners: data?.noOfNewsBanners,
        isContentMarketing: formData?.isContentMarketing,
        isPrintAd: formData?.isPrintAd,
        noOfPosts: data?.noOfPosts,
        printAdd: data?.printAdd,
        contntMarktAdFrom: data?.contntMarktAdFrom
          ? moment(data?.contntMarktAdFrom, "YYYY-MM-DD").format("DD/MM/YYYY")
          : "",
        contntMarktAdTo: data?.contntMarktAdTo
          ? moment(data?.contntMarktAdTo, "YYYY-MM-DD").format("DD/MM/YYYY")
          : "",
        printAdType: data?.printAdType,
        noOfPrintAds: data?.noOfPrintAds,
        additionalService: data?.additionalService,
        isCompanyProfiling: formData?.isCompanyProfiling,
        isEventProfiling: formData?.isEventProfiling,
        eventIdList: data?.eventIdList,

        // mtCurrencyDto:{
        //   id: parseInt(data?.mtCountryDto as unknown as string,10)
        // },
      };
      if (leadId) {
        payload.proposalId = parseInt(leadId, 10);
      } else if (bookingId) {
        payload.id = parseInt(bookingId, 10);
      }
      if (data?.type === "EVENT_ORGANIZER") {
        const eventReqDtos = await Promise.all(
          data?.eventReqDtos?.map(async (event: any, index) => {
            let base64Str = "";
            let name = "";
            let type = "";

            if (file && file[index]) {
              base64Str = await convertFileToBase64(file[index] as File);
              name = (file[index] as File).name;
              type = (file[index] as File).type;
            }

            // Check if the event is empty before setting default values like 'VIRTUAL'
            const isEventEmpty = (event: any) => {
              return (
                event?.name === "" &&
                event?.mtCountryDto === "" &&
                event?.startDate === "" &&
                event?.endDate === "" &&
                event?.link === "" &&
                event?.contactPersonName === "" &&
                event?.contactPersonEmail === "" &&
                event?.phoneNo === "" &&
                event?.venue === "" &&
                base64Str === "" &&
                event?.type === "" // Check before setting 'VIRTUAL'
              );
            };

            // Only return the event object if it's not empty
            if (!isEventEmpty(event)) {
              return {
                id: event?.id || undefined,
                name: event?.name || "",
                startDate: event?.startDate
                  ? moment(event?.startDate, "YYYY-MM-DD").format("DD/MM/YYYY")
                  : "",
                endDate: event?.endDate
                  ? moment(event?.endDate, "YYYY-MM-DD").format("DD/MM/YYYY")
                  : "",
                contactPersonName: event?.contactPersonName || "",
                contactPersonEmail: event?.contactPersonEmail || "",
                phoneNo: event?.phoneNo || "",
                venue: event?.venue || "",
                link: event?.link,
                type: event?.type === "" ? "VIRTUAL" : event?.type, // Assign 'VIRTUAL' if type is empty
                imageDto: {
                  name: name, // File name
                  type: type, // File type
                  base64Str: base64Str || "", // Base64-encoded file
                },
                mtCountryDto: { id: parseInt(event?.mtCountryDto, 10) },
              };
            }

            return null; // Return null for empty events
          }) || []
        );

        // Filter out null values from the array (empty events)
        payload.eventReqDtos = eventReqDtos.filter(
          (event: any) => event !== null
        );

        // If the array is empty after filtering, assign []
        if (payload.eventReqDtos.length === 0) {
          payload.eventReqDtos = [];
        }
      }
      if (leadId) {
        if (userInfo.roles === "SALES_MANAGER") {
          url = API_ENDPOINTS.salesManagerBookProposal;
        } else if (userInfo.roles === "SALES_ADMIN") {
          url = API_ENDPOINTS.salesAdminBookProposal;
        } else if (userInfo.roles === "SALES_TEAM_LEAD") {
          url = API_ENDPOINTS.salesTlBookProposal;
        } else if (userInfo.roles === "SALES_EXECUTIVE") {
          url = API_ENDPOINTS.salesExecutiveBookProposal;
        }
        response = await postService(url, payload);
        setResponseData(response.data.id)
      } else if (bookingId) {
        if (userInfo.roles === "SALES_MANAGER") {
          url = API_ENDPOINTS.updateSalesManagerProposalBooking;
        } else if (userInfo.roles === "SALES_ADMIN") {
          url = API_ENDPOINTS.updateSalesAdminProposalBooking;
        } else if (userInfo.roles === "SALES_TEAM_LEAD") {
          url = API_ENDPOINTS.updateSalesTlProposalBooking;
        } else if (userInfo.roles === "SALES_EXECUTIVE") {
          url = API_ENDPOINTS.updateSalesExecutiveProposalBooking;
        }
        response = await postService(url, payload);
        setResponseData(response.data.id)
      }
      if (response.statusCode === 200) {
        if (selectedTypes === "PAID") {
          setIsShow(true);
          // navigate("/portals/bookings/viewBooking");
        } else {
          setIsShow(false);
            navigate('/portals/bookings/confirmedBooking')
        }
      } else {
        console.error("Error saving user:", response.data);
      }
    } catch (error: any) {
      showToast(error?.response?.data?.message, "error", "");
      console.error("Error saving user:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleChange =
    (panel: string) => (event: React.ChangeEvent<{}>, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
    };
  const handleCountryChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedCountryId = e.target.value;
    setSelectedCountry(selectedCountryId);

    const selectedCountry = mtContryData.find(
      (country: any) => country.id == selectedCountryId
    );
  };
  const formatFileSize = (size: number): string => {
    const i = Math.floor(Math.log(size) / Math.log(1024));
    const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
    return parseFloat((size / Math.pow(1024, i)).toFixed(2)) + " " + sizes[i];
  };
  const handleBooking = () => {
    if (leadId) {
      navigate("/portals/proposals/viewProposal");
    } else if (bookingId) {
      navigate(-1)
      // navigate("/portals/bookings/viewBooking");
    }
  };

  return (
    <div className="h-full py-2 w-full">
      <div className="flex items-center cursor-pointer mb-4">
        <h2
          className="mr-2 text-gray-700 font-semibold text-sm"
          onClick={proposals}
        >
         {bookingId ? 'Booked' :'Proposal'} 
        </h2>{" "}
        <img src="/images/arrowIcons.svg" className="mr-2" />{" "}
        <span className="text-gray-400 font-semibold text-sm">
          {bookingId ? 'Edit Proposal' :'Book Proposal'}
        </span>
      </div>
      <div
        className="flex gap-2 items-center font-Inter pb-7 cursor-pointer"
        onClick={handleBooking}
      >
        <img src="/images/Back or Arrow left (1).svg" />
        <p className="text-[#2D2E2F] font-bold text-2xl">Book Proposal</p>
      </div>
      <form
        onSubmit={handleSubmit(onSubmit)}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.preventDefault(); // Prevent form submission on Enter for all form fields
          }
        }}
      >
        <div>
          <div className="bg-white rounded-md px-6 ">
            <div className="w-full pt-6 scroolCls h-auto">
              <div className="w-[75%] sm:grid grid-cols-1 sm:grid-cols-none md:grid-cols-1 lg:grid-cols-1 gap-4">
                <div className="">
                <p className="font-bold text-xl pb-4">
                Order Form for {submittedData?.companyName}
                      </p>
                  <div className="grid grid-cols-2 gap-10">
                  <div className="form-group mb-4 sm:mb-0 w-[380px]">
                    <div className="mb-[20px]">
                      <label className="mb-1 ml-1 font-semibold text-gray-700 text-sm">
                        Type <span className="font-[400]"> (Required)</span> {" "}
                      </label>
                      <div className="relative">
                        <select
                          {...register("type", {
                            required: "Type is required",
                          })}
                          onChange={handleTypeChange}
                          disabled={isEditMode} 
                          // disabled={isDisabled}
                          className={`form-control p-2 rounded mt-1 w-full ${
                            errors.type
                              ? "border-[#B91C1C] border-2"
                              : "border-gray-300 border"
                          }`}
                        >
                          <option value="">Select type</option>
                          {submittedData?.proposalType === "EVENT_ORGANIZER" ||
                            submittedData?.type === "EVENT_ORGANIZER" ? (
                            <>
                              <option value="PAID">Paid</option>
                              <option value="BARTER">Barter</option>
                            </>
                          ) : (
                            <>
                              <option value="PAID">Paid</option>
                              <option value="TRIAL">Trial</option>
                              <option value="INVITE">Invite</option>
                            </>
                          )}
                        </select>
                      </div>
                      {errors.type && (
                        <p className="text-[#B91C1C] font-[500] text-sm mt-1">
                          {errors.type.message}
                        </p>
                      )}
                    </div>
                  </div>
                  <div
                    className="form-group mb-[20px] sm:mb-0"
                    style={{ marginBottom: "20px" }}
                  >
                    <label className="mb-1 ml-1 font-semibold text-gray-700 text-sm">
                      Booking date{" "}
                      <span className="font-[400]"> (Required)</span>
                    </label>
                    <div className="relative">
                      <input
                        type="date"
                        min={today}
                        onClick={handleDateClick}
                        value={selectedDate}
                       
                        // onFocus={(e) => e.target.showPicker()}
                        placeholder="Enter your Call back date"
                        {...register("bookingDate", {
                          required: "Booking date is required",
                          onChange: (e) => {
                            handleDateChange(e); // Call your handleDateChange function
                            setSelectedDate(e.target.value); // Update the selectedDate state
                          },
                        })}
                        className={`form-control mt-1 p-2 rounded w-full font-medium ${
                          errors.bookingDate
                            ? "border border-[#B91C1C]"
                            : "border border-gray-300"
                        }`}
                      />
                      {errors.bookingDate && (
                        <p className="text-[#B91C1C] font-[500] text-sm mt-1">
                          {errors.bookingDate.message}
                        </p>
                      )}
                    </div>
                  </div>
                  </div>
                  {(selectedTypes === "PAID") && (
                    <div className="form-group sm:mb-0 md:mb-5 grid grid-cols-2">
                      <label className="mb-1 ml-1 font-semibold text-gray-700 text-sm">
                        Booking value
                        {selectedTypes === "PAID" && <span className="font-[400]"> (Required)</span>}
                      </label>
                      <div></div>
                      <div className="flex border border-gray-300 rounded mt-1 form-control w-[380px] overflow-hidden">
                        <div className="flex items-center px-3 text-gray-700 font-semibold text-sm">
                          {getCurrencySymbol(currencyCodes)}
                        </div>
                        <input
                          type="text"
                          placeholder="0.00"
                          {...register("value", {
                            required: selectedTypes === "PAID" ? "Booking value is required" : false,
                          })}
                          className={`w-full p-2 text-sm text-gray-700 border-gray-300 focus:outline-none ${
                            errors.value ? "border-red-500" : ""
                          }`}
                        />
                        <select
                          value={currencyCodes || ""}
                          {...register("mtCurrencyDto")}
                          onChange={currencyCode}
                          className="bg-white py-2 text-sm font-semibold text-gray-700 focus:outline-none"
                        >
                          <option value="">Select</option>
                          {mtCurrencyData.map((item: any) => (
                            <option
                              key={item.id}
                              value={item.id !== null ? item.id : ""}
                            >
                              {item.name}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div></div>
                      {errors.value && (
                        <p className="text-[#B91C1C] font-[500] text-sm mt-1">
                          {errors.value.message}
                        </p>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          {/* {(submittedData?.proposalType === "HOSPITAL" ||
            submittedData?.type === "HOSPITAL" ||
            submittedData?.proposalType === "EVENT_ORGANIZER" ||
            submittedData?.type === "EVENT_ORGANIZER" ||
            submittedData?.proposalType === "COMPANY" ||
            submittedData?.type === "COMPANY") && ( */}
            <>
              {(selectedTypes === "PAID" || selectedType === 'BARTER') && (
                <>
                  <p className="pt-4 text-xl font-bold font-sans mb-4 px-6">
                    Select Services <span className="font-[400] text-sm text-gray-700"> (Required)</span>
                  </p>
                  <div className="bg-white rounded-md px-6 h-[50vh] scroolCls overflow-y-scroll">
                    <div className="w-full pt-6 scroolCls h-auto">
                      <div className="w-[62%] sm:grid grid-cols-1 sm:grid-cols-none md:grid-cols-1 lg:grid-cols-1 gap-4">
                        <div className="grid grid-cols-1 gap-4">
                          {(submittedData?.proposalType === "HOSPITAL" ||
                            submittedData?.type === "HOSPITAL") && (
                            <>
                              <div className="flex items-center gap-3 pb-2">
                                <input
                                  type="checkbox"
                                  checked={formData.isHospitalProfiling}
                                  onChange={(e) =>
                                    handleCheckboxChange(
                                      e,
                                      "isHospitalProfiling"
                                    )
                                  }
                                  className="p-2 form-checkbox accent-[#B00A2B] focus:accent-[#B00A2B] rounded-lg border border-gray-300 h-4 w-4"
                                />
                                <p className="text-[#111827] text-sm font-bold">
                                  Hospital Profiling
                                </p>
                              </div>
                              
                            </>
                          )}

                          {(submittedData?.proposalType === "EVENT_ORGANIZER" ||
                            submittedData?.type === "EVENT_ORGANIZER") && (
                            <>
                              <div className="flex items-center gap-3 pb-2">
                                <input
                                  type="checkbox"
                                  checked={formData.isEventProfiling}
                                  onChange={(e) =>
                                    handleCheckboxChange(e, "isEventProfiling")
                                  }
                                  className="p-2 form-checkbox accent-[#B00A2B] focus:accent-[#B00A2B] rounded-lg border border-gray-300 h-4 w-4"
                                />
                                <p className="text-[#111827] text-sm font-bold">
                                  Event Organiser Profiling
                                </p>
                              </div>
                              <div className="flex items-center gap-3 pb-2">
                                <input
                                  type="checkbox"
                                  checked={formData.isEventListing}
                                  onChange={(e) =>
                                    handleCheckboxChange(e, "isEventListing")
                                  }
                                  className="p-2 form-checkbox accent-[#B00A2B] focus:accent-[#B00A2B] rounded-lg border border-gray-300 h-4 w-4"
                                />
                                <p className="text-[#111827] text-sm font-bold">
                                  Event Listing
                                </p>
                              </div>
                            </>
                          )}

                          {(submittedData?.proposalType === "COMPANY" ||
                            submittedData?.type === "COMPANY") && (
                            <div className="flex items-center gap-3 pb-2">
                              <input
                                type="checkbox"
                                checked={formData.isCompanyProfiling}
                                onChange={(e) =>
                                  handleCheckboxChange(e, "isCompanyProfiling")
                                }
                                className="p-2 form-checkbox accent-[#B00A2B] focus:accent-[#B00A2B] rounded-lg border border-gray-300 h-4 w-4"
                              />
                              <p className="text-[#111827] text-sm font-bold">
                                Company Profiling
                              </p>
                            </div>
                          )}

                          <div className="flex items-center gap-3 pb-2">
                            <input
                              type="checkbox"
                              checked={formData.isBannerAds}
                              onChange={(e) =>
                                handleCheckboxChange(e, "isBannerAds")
                              }
                              className="p-2 form-checkbox accent-[#B00A2B] focus:accent-[#B00A2B] rounded-lg border border-gray-300 h-4 w-4"
                            />
                            <p className="text-[#111827] text-sm font-bold">
                              Banner Ads (Website)
                            </p>
                          </div>
                          {formData.isBannerAds && (
                            <div className="grid grid-cols-2 gap-4">
                              <div className=" form-group">
                                <label className="mb-1 ml-1 font-semibold text-gray-700 text-sm">
                                  Start Date{" "}
                                </label>
                                <div className="flex border border-gray-300 rounded-md mt-1 form-control overflow-hidden w-[303px]">
                                                            <input
                              type="date"
                              min={today}
                              onClick={handleDateClick}
                              placeholder="Enter Start Date"
                              {...register("bannerAdFrom", {
                                required: formData.isBannerAds ? "Start Date is required" : false,
                                onChange: handleStartDateChange1 // Move onChange here
                              })}
                              className="w-full p-2 text-sm text-gray-700 border-gray-300 focus:outline-none"
                            />
                                </div>
                                {errors.bannerAdFrom && (
                                  <p className="text-[#B91C1C] font-[500] text-sm mt-1">
                                    {errors.bannerAdFrom.message}
                                  </p>
                                )}
                              </div>
                              <div className="form-group ">
                                <label className="mb-1 ml-1 font-semibold text-gray-700 text-sm">
                                  End Date{" "}
                                </label>
                                <div className="flex border border-gray-300 rounded mt-1 form-control overflow-hidden w-[303px]">
                                  <input
                                    type="date"
                                    onClick={handleDateClick}
                                    placeholder="Enter End Date"
                                    min={endDate1}
                                    {...register("bannerAdTo", {
                                      required: formData.isBannerAds
                                        ? "End Date is required"
                                        : false,
                                    })}
                                    className="w-full p-2 text-sm text-gray-700 border-gray-300 focus:outline-none"
                                  />
                                </div>
                                {errors.bannerAdTo && (
                                  <p className="text-[#B91C1C] font-[500] text-sm mt-1">
                                    {errors.bannerAdTo.message}
                                  </p>
                                )}
                              </div>
                            </div>
                          )}
                          {formData.isBannerAds && (
                            <div className="grid grid-cols-2 gap-4">
                              <div className="form-group mb-4 sm:mb-0 w-[303px]">
                                <label className="mb-1 ml-1 font-semibold text-gray-700 text-sm">
                                  Number of Banners
                                </label>
                                <div className="relative">
                                  <input
                                    type="text"
                                    placeholder="Enter number of banners"
                                    {...register("noOfBanners", {
                                      required: formData.isBannerAds
                                        ? "Number of Banners is required"
                                        : false,
                                    })}
                                    className={`form-control mt-1 p-2 rounded w-full font-medium ${
                                      errors.noOfBanners
                                        ? "border border-[#B91C1C]"
                                        : "border border-gray-300"
                                    }`}
                                    style={{
                                      outline: errors.noOfBanners
                                        ? "2px solid red"
                                        : "none",
                                    }}
                                  />
                                  {errors.noOfBanners && (
                                    <p className="text-[#B91C1C] font-[500] text-sm mt-1">
                                      {errors.noOfBanners.message}
                                    </p>
                                  )}
                                </div>
                              </div>
                            </div>
                          )}
                          <div className="grid grid-cols-2 gap-4">
                            <div className="flex items-center gap-3 pb-2 ">
                              <input
                                type="checkbox"
                                checked={formData.isEmailMarketing}
                                onChange={(e) =>
                                  handleCheckboxChange(e, "isEmailMarketing")
                                }
                                className="p-2 form-checkbox accent-[#B00A2B] focus:accent-[#B00A2B] rounded-lg border border-gray-300 h-4 w-4"
                              />
                              <p className="text-[#111827] text-sm font-bold">
                                Email Marketing
                              </p>
                            </div>
                            <div></div>
                            {formData.isEmailMarketing && (
                              <div className="w-[303px]">
                                <input
                                  type="text"
                                  placeholder="Recepients Counts Given"
                                  {...register("noOfRecipients", {
                                    required:
                                      "Number of Recipients is required",
                                  })}
                                  className={`form-control mt-1 p-2 rounded w-full font-medium ${
                                    errors.noOfRecipients
                                      ? "border border-[#B91C1C]"
                                      : "border border-gray-300"
                                  }`}
                                  style={{
                                    outline: errors.noOfRecipients
                                      ? "2px solid red"
                                      : "none",
                                  }}
                                />

                                {errors.noOfRecipients && (
                                  <p className="text-[#B91C1C] font-[500] text-sm mt-1">
                                    {errors.noOfRecipients.message}
                                  </p>
                                )}
                                <input
                                  type="text"
                                  placeholder="Number of EDM'S"
                                  {...register("noOfEdms", {
                                    required: "Number of EDMS is required",
                                  })}
                                  className={`form-control p-2 rounded w-full font-medium mt-5 ${
                                    errors.noOfEdms
                                      ? "border border-[#B91C1C]"
                                      : "border border-gray-300"
                                  }`}
                                  style={{
                                    outline: errors.noOfEdms
                                      ? "2px solid red"
                                      : "none",
                                  }}
                                />
                                {errors.noOfEdms && (
                                  <p className="text-[#B91C1C] font-[500] text-sm mt-1">
                                    {errors.noOfEdms.message}
                                  </p>
                                )}
                              </div>
                            )}
                          </div>
                          <div className="flex items-center gap-3 pb-2">
                            <input
                              type="checkbox"
                              checked={formData.isNewsLetterAds}
                              onChange={(e) =>
                                handleCheckboxChange(e, "isNewsLetterAds")
                              }
                              className="p-2 form-checkbox accent-[#B00A2B] focus:accent-[#B00A2B] rounded-lg border border-gray-300 h-4 w-4"
                            />
                            <p className="text-[#111827] text-sm font-bold">
                              Ads in e-newsletter
                            </p>
                          </div>
                          {formData.isNewsLetterAds && (
                            <div className="grid grid-cols-2 gap-4">
                              <div className=" form-group">
                                <label className="mb-1 ml-1 font-semibold text-gray-700 text-sm">
                                  Start Date{" "}
                                </label>
                                <div className="flex border border-gray-300 rounded-md mt-1 form-control overflow-hidden w-[303px]">
                                  <input
                                    type="date"
                                    min={today}
                                    onClick={handleDateClick}
                                    placeholder="Enter Start Date"
                                    {...register("newsLetterAdFrom", {
                                      required: "Start date is required",
                                      onChange: handleStartDateChange
                                    })}
                                    className="w-full p-2 text-sm text-gray-700 border-gray-300 focus:outline-none"
                                  />
                                </div>
                                {errors.newsLetterAdFrom && (
                                  <p className="text-[#B91C1C] font-[500] text-sm mt-1">
                                    {errors.newsLetterAdFrom.message}
                                  </p>
                                )}
                              </div>
                              <div className="form-group ">
                                <label className="mb-1 ml-1 font-semibold text-gray-700 text-sm">
                                  End Date{" "}
                                </label>
                                <div className="flex border border-gray-300 rounded mt-1 form-control overflow-hidden w-[303px]">
                                  <input
                                    type="date"
                                    onClick={handleDateClick}
                                    min={endDate}
                                    placeholder="Enter End Date"
                                    {...register("newsLetterAdTo", {
                                      required: "End date is required",
                                    })}
                                    className="w-full p-2 text-sm text-gray-700 border-gray-300 focus:outline-none"
                                  />
                                </div>
                                {errors.newsLetterAdTo && (
                                  <p className="text-[#B91C1C] font-[500] text-sm mt-1">
                                    {errors.newsLetterAdTo.message}
                                  </p>
                                )}
                              </div>
                              <div className="w-[303px]">
                                <input
                                  type="text"
                                  placeholder="Number of Banners"
                                  {...register("noOfNewsBanners", {
                                    required: "Number of banners is required",
                                  })}
                                  className={`form-control mt-1 p-2 rounded w-full font-medium ${
                                    errors.noOfNewsBanners
                                      ? "border border-[#B91C1C]"
                                      : "border border-gray-300"
                                  }`}
                                  style={{
                                    outline: errors.noOfNewsBanners
                                      ? "2px solid red"
                                      : "none",
                                  }}
                                />
                                {errors.noOfNewsBanners && (
                                  <p className="text-[#B91C1C] font-[500] text-sm mt-1">
                                    {errors.noOfNewsBanners.message}
                                  </p>
                                )}
                              </div>
                            </div>
                          )}
                          <div className="grid grid-cols-2 gap-4">
                            <div className="flex items-center gap-3 pb-2">
                              <input
                                type="checkbox"
                                checked={formData.isContentMarketing}
                                onChange={(e) =>
                                  handleCheckboxChange(e, "isContentMarketing")
                                }
                                className="p-2 form-checkbox accent-[#B00A2B] focus:accent-[#B00A2B] rounded-lg border border-gray-300 h-4 w-4"
                              />
                              <p className="text-[#111827] text-sm font-bold">
                                Content Marketing
                              </p>
                            </div>
                            <div></div>

                            {formData.isContentMarketing && (
                              <div className="mb-1 w-[303px]">
                                <input
                                  type="text"
                                  placeholder="Number of Posts"
                                  {...register("noOfPosts", {
                                    required: "Number of posts are required",
                                  })}
                                  className={`form-control mt-1 p-2 rounded w-full font-medium ${
                                    errors.noOfPosts
                                      ? "border border-[#B91C1C]"
                                      : "border border-gray-300"
                                  }`}
                                  style={{
                                    outline: errors.noOfPosts
                                      ? "2px solid red"
                                      : "none",
                                  }}
                                />
                                {errors.noOfPosts && (
                                  <p className="text-[#B91C1C] font-[500] text-sm mt-1">
                                    {errors.noOfPosts.message}
                                  </p>
                                )}
                              </div>
                            )}

                            {/* <div></div> */}
                          </div>
                          {formData.isContentMarketing && (
                            <div className="flex gap-4">
                              <div className=" form-group w-full">
                                <label className="mb-1 ml-1 font-semibold text-gray-700 text-sm">
                                  Start Date{" "}
                                </label>
                                <div className="flex border border-gray-300 rounded-md mt-1 form-control overflow-hidden w-[303px]">
                                  <input
                                    type="date"
                                    min={today}
                                    onClick={handleDateClick}
                                    placeholder="Enter Start Date"
                                    {...register("contntMarktAdFrom", {
                                      required: "Start date is required",
                                      onChange: handleStartDateChange2
                                    })}
                                    className="w-full p-2 text-sm text-gray-700 border-gray-300 focus:outline-none"
                                  />
                                </div>
                                {errors.contntMarktAdFrom && (
                                  <p className="text-[#B91C1C] font-[500] text-sm mt-1">
                                    {errors.contntMarktAdFrom.message}
                                  </p>
                                )}
                              </div>
                              <div className="form-group w-full">
                                <label className="mb-1 ml-1 font-semibold text-gray-700 text-sm">
                                  End Date{" "}
                                </label>
                                <div className="flex border border-gray-300 rounded mt-1 form-control overflow-hidden w-[303px]">
                                  <input
                                    type="date"
                                    onClick={handleDateClick}
                                    min={endDate2}
                                    placeholder="Enter End Date"
                                    {...register("contntMarktAdTo", {
                                      required: "End date is required",
                                    })}
                                    className="w-full p-2 text-sm text-gray-700 border-gray-300 focus:outline-none"
                                  />
                                </div>
                                {errors.contntMarktAdTo && (
                                  <p className="text-[#B91C1C] font-[500] text-sm mt-1">
                                    {errors.contntMarktAdTo.message}
                                  </p>
                                )}
                              </div>
                            </div>
                          )}
                          <div className="flex items-center gap-3">
                            <input
                              type="checkbox"
                              checked={formData.isPrintAd}
                              onChange={(e) =>
                                handleCheckboxChange(e, "isPrintAd")
                              }
                              className="p-2 form-checkbox accent-[#B00A2B] focus:accent-[#B00A2B] rounded-lg border border-gray-300 h-4 w-4"
                            />
                            <p className="text-[#111827] text-sm font-bold">
                              Print Advertisement
                            </p>
                          </div>
                          <div className="grid grid-cols-2 gap-4">
                            {formData.isPrintAd && (
                              <div className="form-group">
                                <div className="relative mb-5 w-[303px]">
                                  <textarea
                                    placeholder="Add type of Advertisement.."
                                    rows={2}
                                    {...register("printAdd", {
                                      required: "Description is required",
                                    })}
                                    className=" border mt-1 p-2 rounded w-full"
                                  ></textarea>
                                  {errors.printAdd && (
                                    <p className="text-[#B91C1C] font-[500] text-sm">
                                      {errors.printAdd.message}
                                    </p>
                                  )}
                                </div>
                                <div></div>
                                <div className="w-[303px]">
                                  <input
                                    type="text"
                                    placeholder={
                                      submittedData?.proposalType ===
                                        "EVENT_ORGANIZER" ||
                                      submittedData?.type === "EVENT_ORGANIZER"
                                        ? "Number of Advertisements"
                                        : "Number of Issues"
                                    }
                                    {...register("noOfPrintAds", {
                                      required:
                                        submittedData?.proposalType ===
                                          "EVENT_ORGANIZER" ||
                                        submittedData?.type ===
                                          "EVENT_ORGANIZER"
                                          ? "Number of advertisements is required"
                                          : "Number of issues is required",
                                    })}
                                    className={`form-control mt-1 p-2 rounded w-full font-medium ${
                                      errors.noOfPrintAds
                                        ? "border border-[#B91C1C]"
                                        : "border border-gray-300"
                                    }`}
                                    style={{
                                      outline: errors.noOfPrintAds
                                        ? "2px solid red"
                                        : "none",
                                    }}
                                  />
                                  {errors.noOfPrintAds && (
                                    <p className="text-[#B91C1C] font-[500] text-sm mt-1">
                                      {errors.noOfPrintAds.message}
                                    </p>
                                  )}
                                </div>
                              </div>
                            )}
                          </div>
                          
                              <div className="grid grid-cols-2 gap-4">
                                <div className="mb-14 w-[303px]">
                                  <p className="text-[#111827] text-sm font-bold">Additional Services</p>
                                  <textarea
                                    placeholder="Write additional services each one in new line"
                                    rows={2}
                                    {...register("additionalService")}
                                    className="border mt-1 p-2 rounded w-full"
                                    onKeyDown={(e) => {
                                      if (e.key === 'Enter' && e.shiftKey) {
                                        e.preventDefault();
                                        const textarea = e.target as HTMLTextAreaElement; // Cast e.target to HTMLTextAreaElement
                                        const start = textarea.selectionStart;
                                        const end = textarea.selectionEnd;
                                        const value = textarea.value;
                                        // Insert a newline character at the current cursor position
                                        textarea.value = value.slice(0, start) + '\n' + value.slice(end);
                                        // Set the cursor after the newline
                                        textarea.selectionStart = textarea.selectionEnd = start + 1;
                                      }
                                    }}
                                  ></textarea>
                                </div>
                              </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}

              {selectedTypes === "TRIAL" &&
                (submittedData?.proposalType === "COMPANY" ||
                  submittedData?.type === "COMPANY" ||
                  submittedData?.proposalType === "HOSPITAL" ||
                  submittedData?.type === "HOSPITAL" ||
                  submittedData?.proposalType === "EVENT_ORGANIZER" ||
                  submittedData?.type === "EVENT_ORGANIZER") && (
                  <>
                    <p className="pt-4 text-xl font-bold font-sans mb-4 px-6">
                      Select Services <span className="font-[400] text-sm text-gray-700"> (Required)</span>
                    </p>
                    <div className="bg-white rounded-md px-6 h-[40vh] scroolCls overflow-y-scroll">
                      <div className="w-full pt-6 scroolCls h-auto">
                        <div className="w-[65%] sm:grid grid-cols-1 sm:grid-cols-none md:grid-cols-1 lg:grid-cols-1 gap-4">
                          <div className="grid grid-cols-2 gap-4">
                            <div className="flex items-center gap-3">
                              <input
                                type="checkbox"
                                checked={formData.isContentMarketing}
                                onChange={(e) =>
                                  handleCheckboxChange(e, "isContentMarketing")
                                }
                                className="p-2 form-checkbox accent-[#B00A2B] focus:accent-[#B00A2B] rounded-lg border border-gray-300 h-4 w-4"
                              />
                              <p className="text-[#111827] text-sm font-bold">
                                Content Marketing
                              </p>
                            </div>
                            <div></div>
                            <div>
                              {formData.isContentMarketing && (
                                <>
                                  <div className="mb-1 w-[303px]">
                                    <input
                                      type="text"
                                      placeholder="Number of Posts"
                                      {...register("noOfPosts", {
                                        required:
                                          "Number of posts are required",
                                      })}
                                      className={`form-control mt-1 p-2 rounded w-full font-medium ${
                                        errors.noOfPosts
                                          ? "border border-[#B91C1C]"
                                          : "border border-gray-300"
                                      }`}
                                      style={{
                                        outline: errors.noOfPosts
                                          ? "2px solid red"
                                          : "none",
                                      }}
                                    />
                                    {errors.noOfPosts && (
                                      <p className="text-[#B91C1C] font-[500] text-sm mt-1">
                                        {errors.noOfPosts.message}
                                      </p>
                                    )}
                                  </div>
                                  {/* <p className="flex items-center justify-center font-semibold text-gray-700 text-sm my-2">
                                    OR
                                  </p> */}
                                  <div className="mt-3">
                                    <label className="mb-1 ml-1 font-semibold text-gray-700 text-sm">
                                      Trial end date{" "}
                                    </label>
                                    <div className="flex border border-gray-300 rounded-md mt-1 form-control overflow-hidden w-[303px]">
                                      <input
                                        type="date"
                                        min={today}
                                        onClick={handleDateClick}
                                        // onChange={handleStartDateChange}
                                        placeholder="Enter Start Date"
                                        {...register("trialEndDate", {
                                          required: formData.isContentMarketing
                                            ? "Trial end Date is required"
                                            : false,
                                        })}
                                        className="w-full p-2 text-sm text-gray-700 border-gray-300 focus:outline-none"
                                      />
                                    </div>
                                  </div>
                                  {errors.trialEndDate && (
                                    <p className="text-[#B91C1C] font-[500] text-sm mt-1">
                                      {errors.trialEndDate.message}
                                    </p>
                                  )}
                                </>
                              )}
                            </div>
                            <div></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                )}

              {selectedTypes === "INVITE" &&
                (submittedData?.proposalType === "COMPANY" ||
                  submittedData?.type === "COMPANY" ||
                  submittedData?.proposalType === "HOSPITAL" ||
                  submittedData?.type === "HOSPITAL" ||
                  submittedData?.proposalType === "EVENT_ORGANIZER" ||
                  submittedData?.type === "EVENT_ORGANIZER") && (
                  <>
                    <p className="pt-4 text-xl font-bold font-sans mb-4 px-6">
                      Select Services <span className="font-[400] text-sm tetx-gray-700"> (Required)</span>
                    </p>
                    <div className="bg-white rounded-md px-6 h-[300px] scroolCls overflow-y-scroll">
                      <div className="w-full pt-6 scroolCls h-auto">
                        <div className="w-[65%] sm:grid grid-cols-1 sm:grid-cols-none md:grid-cols-1 lg:grid-cols-1 gap-4">
                          <div className="grid grid-cols-2 gap-4">
                            {(submittedData?.proposalType === "HOSPITAL" ||
                              submittedData?.type === "HOSPITAL") && (
                              <>
                                <div className="flex items-center gap-3 pb-2">
                                  <input
                                    type="checkbox"
                                    checked={formData.isHospitalProfiling}
                                    onChange={(e) =>
                                      handleCheckboxChange(
                                        e,
                                        "isHospitalProfiling"
                                      )
                                    }
                                    className=" form-checkbox accent-[#B00A2B] focus:accent-[#B00A2B] rounded-lg border border-gray-300 h-4 w-4"
                                  />
                                  <p className="text-[#111827] text-sm font-bold">
                                    Hospital Profiling
                                  </p>
                                </div>
                                {/* <div></div> */}
                                {/* <div className="flex items-center gap-3 pb-2">
                                  <input
                                    type="checkbox"
                                    checked={formData.isCenterListing}
                                    onChange={(e) =>
                                      handleCheckboxChange(e, "isCenterListing")
                                    }
                                    className="p-2 form-checkbox accent-[#B00A2B] focus:accent-[#B00A2B] rounded-lg border border-gray-300 h-4 w-4"
                                  />
                                  <p className="text-[#111827] text-sm font-bold">
                                    Centre Listing
                                  </p>
                                </div> */}
                                <div></div>
                              </>
                            )}
                            {(submittedData?.proposalType === "COMPANY" ||
                              submittedData?.type === "COMPANY") && (
                              <div className="flex items-center gap-3 pb-2 col-span-2">
                                <input
                                  type="checkbox"
                                  checked={formData.isCompanyProfiling}
                                  onChange={(e) =>
                                    handleCheckboxChange(
                                      e,
                                      "isCompanyProfiling"
                                    )
                                  }
                                  className="p-2 form-checkbox accent-[#B00A2B] focus:accent-[#B00A2B] rounded-lg border border-gray-300 h-4 w-4"
                                />
                                <p className="text-[#111827] text-sm font-bold">
                                  Company Profiling
                                </p>
                              </div>
                            )}
                            {(submittedData?.proposalType ===
                              "EVENT_ORGANIZER" ||
                              submittedData?.type === "EVENT_ORGANIZER") && (
                              <>
                                <div className="flex items-center gap-3 pb-2">
                                  <input
                                    type="checkbox"
                                    checked={formData.isEventProfiling}
                                    onChange={(e) =>
                                      handleCheckboxChange(
                                        e,
                                        "isEventProfiling"
                                      )
                                    }
                                    className="p-2 form-checkbox accent-[#B00A2B] focus:accent-[#B00A2B] rounded-lg border border-gray-300 h-4 w-4"
                                  />
                                  <p className="text-[#111827] text-sm font-bold">
                                    Event Organiser Profiling
                                  </p>
                                </div>
                                <div></div>
                                <div className="flex items-center gap-3 pb-2">
                                  <input
                                    type="checkbox"
                                    checked={formData.isEventListing}
                                    onChange={(e) =>
                                      handleCheckboxChange(e, "isEventListing")
                                    }
                                    className="p-2 form-checkbox accent-[#B00A2B] focus:accent-[#B00A2B] rounded-lg border border-gray-300 h-4 w-4"
                                  />
                                  <p className="text-[#111827] text-sm font-bold">
                                    Event Listing
                                  </p>
                                </div>
                                <div></div>
                              </>
                            )}
                            <div className="flex items-center gap-3">
                              <input
                                type="checkbox"
                                checked={formData.isContentMarketing}
                                onChange={(e) =>
                                  handleCheckboxChange(e, "isContentMarketing")
                                }
                                className="p-2 form-checkbox accent-[#B00A2B] focus:accent-[#B00A2B] rounded-lg border border-gray-300 h-4 w-4"
                              />
                              <p className="text-[#111827] text-sm font-bold">
                                Content Marketing
                              </p>
                            </div>
                            <div></div>
                            <div>
                              {formData.isContentMarketing && (
                                <>
                                  <div className="mb-1 w-[303px]">
                                    <input
                                      type="text"
                                      placeholder="Number of Posts"
                                      {...register("noOfPosts", {
                                        required:
                                          "Number of posts are required",
                                      })}
                                      className={`form-control mt-1 p-2 rounded w-full font-medium ${
                                        errors.noOfPosts
                                          ? "border border-[#B91C1C]"
                                          : "border border-gray-300"
                                      }`}
                                      style={{
                                        outline: errors.noOfPosts
                                          ? "2px solid red"
                                          : "none",
                                      }}
                                    />
                                    {errors.noOfPosts && (
                                      <p className="text-[#B91C1C] font-[500] text-sm mt-1">
                                        {errors.noOfPosts.message}
                                      </p>
                                    )}
                                  </div>
                                  {/* <p className="flex items-center justify-center font-semibold text-gray-700 text-sm my-2">
                                    OR
                                  </p> */}
                                  <div className="mt-3">
                                    <div className="font-semibold text-gray-700 text-sm">
                                      <label className="mb-1 ml-1 font-semibold text-gray-700 text-sm">
                                        Invite end date{" "}
                                      </label>
                                      <div className="flex border border-gray-300 rounded-md mt-1 form-control overflow-hidden w-[303px]">
                                        <input
                                          type="date"
                                          min={today}
                                          onClick={handleDateClick}
                                          // onChange={handleStartDateChange}
                                          placeholder="Enter Start Date"
                                          {...register("inviteEndDate", {
                                            required: formData.isContentMarketing
                                              ? "Invite end Date is required"
                                              : false,
                                          })}
                                          className="w-full p-2 text-sm text-gray-700 border-gray-300 focus:outline-none"
                                        />
                                      </div>
                                    </div>
                                    {errors.inviteEndDate && (
                                      <p className="text-[#B91C1C] font-[500] text-sm mt-1">
                                        {errors.inviteEndDate.message}
                                      </p>
                                    )}
                                  </div>
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                )}

              <div className="fixed bottom-[1px] w-[80%]">
                <div
                  className="flex justify-end  p-4 items-center  bg-white bottom-[20px]"
                  style={{
                    boxShadow: "0px -16px 50px 0px #0000000D",
                  }}
                >
                  <button
                    type="submit"
                    className={`px-4 py-2 border border-gray-300 text-gray-600  rounded-[8px] font-bold text-base mr-3`}
                    onClick={usersScreen}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    disabled={!isAnyServiceSelected() || Object.keys(errors).length > 0}
                    
                    // disabled={!isValid || isSubmitting || isBollen}
                    className={`px-4 py-2 gradient-background text-white rounded font-bold text-base ${!isAnyServiceSelected() || Object.keys(errors).length > 0 ? "opacity-50 cursor-not-allowed" : ""} `}
                  >
                    {userId ? "Confirm" : "Update"}
                  </button>
                </div>
              </div>
            </>
          {/* )} */}
        </div>
      </form>
      {isPopupOpen && (
        <ConfirmationModal
          onClose={handleClosePopup}
          onConfirm={handleConfirm}
          isUpdate={searchParams.size !== 0 ? "update" : "submit"}
          nameOfScreen="bookings"
          bookingTypes={selectedTypes}
          statusValue={submittedData?.status || ""}
        />
      )}
      {isShow && (
        <Sucesspopup
          addUser={closePopup}
          // download={handleDownloadBookingForm}
          download={() => handleDownloadBookingForm({ id: bookingId })}
          // viewUser={viewUsers}
          emailId={submittedData?.email || ""}
          isUpdate={bookingId ? "update" : "add"}
          nameOfScreen="bookings"
          statusValue={submittedData?.status || ""}
          viewUser={function (): void {
            throw new Error("Function not implemented.");
          } } upload={function (): void {
            throw new Error("Function not implemented.");
          } } confirm={function (): void {
            throw new Error("Function not implemented.");
          } }        />
      )}
    </div>
  );
};

export default AddBooking;
